import React from "react";
import { View } from "react-native";
import { HelperText, SegmentedButtons, Text } from "react-native-paper";
import { useTranslation } from "react-i18next";

import {Field} from "../config/companies/config";

interface SegmentedButtonsFieldProps {
  field: Field;
  value: string;
  onChange: (fieldName: string, newValue: any) => void;
  errors?: Record<string, any>;
}

const SegmentedButtonsField = ({
  field,
  value,
  onChange,
  errors = {},
}: SegmentedButtonsFieldProps) => {
  const { t } = useTranslation();
  const label = t(field.label) + (field.required ? "*" : "");

  const handleChange = (newValue: string) => {
    onChange(field.name, newValue);
  };

  return (
    <View>
      {!field.hideLabel && <Text style={{ marginBottom: 8 }}>{label}</Text>}
      <SegmentedButtons
        value={value || field.defaultValue || ""}
        onValueChange={handleChange}
        buttons={
          field.options?.map((option) => ({
            value: option,
            label: t(option),
          })) || []
        }
      />
      {errors[field.name] && (
        <HelperText type="error">{t(errors[field.name])}</HelperText>
      )}
    </View>
  );
};

export default SegmentedButtonsField;
